import TabsHeader from 'components/tabs-header';
import { useAccountState } from 'contexts/account/account-context';
import React from 'react';
import { FileText } from 'lucide-react';
import { useIntl } from 'react-intl';
import { UserFeatures } from 'types/user-features.enum';

type Props = {
  intro?: React.ReactNode;
  actions?: React.ReactNode;
  utils?: React.ReactNode;
};

const ShrimpDataUploadTabsHeader: React.FC<Props> = ({ intro, actions, utils }) => {
  const intl = useIntl();
  const {
    account: { currentUser },
  } = useAccountState();

  return (
    <TabsHeader
      tabs={[
        {
          hasAccess: currentUser?.userFeatures?.includes(UserFeatures.ShrimpDataUpload),
          label: intl.formatMessage({ id: 'shrimpDataUpload.navigation.viewShrimpDataUpload' }),
          to: '/shrimp-upload',
        },
      ]}
      intro={intro}
      actions={actions}
      utils={utils}
      icon={<FileText size={25} color={'white'} />}
    />
  );
};

export default React.memo(ShrimpDataUploadTabsHeader);
